/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import Brushaway from '@components/Brushaway';
import BuildingSelector from '@components/v2/BuildingSelector';
import { Button } from '@ui';
import ExternalEntitySelector from '@components/v2/ExternalEntitySelector';
import { translate } from '@utils/i18n';
import RunAiButton from './RunAiButton';
import { useRunIA } from '../hooks/useRunIA';
import './TryNowModalStyles.scss';
const namespace = 'whats_new_modal';
export default function TryNowModal({ isOpen, onClose, allowBack = false, onCloseModal }) {
    var _a;
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [selectedInspection, setSelectedInspection] = useState(null);
    const runIAMutation = useRunIA();
    const handleBuildingChange = (building) => {
        setSelectedBuilding(building);
        setSelectedInspection(null); // Reset inspection when building changes
    };
    const handleInspectionChange = (inspection) => {
        setSelectedInspection(inspection);
    };
    const handleRunInspectionManager = () => {
        if (!selectedInspection)
            return;
        const inspection = selectedInspection;
        const inspectionId = Number(inspection.id);
        const targetUrl = `/inspections/${encodeURIComponent(inspection.id)}#iim-issues`;
        const runWindow = window.open(targetUrl, '_blank', 'noopener');
        runIAMutation.mutate({
            inspectionId,
            visibility: 'back_office_only',
            isFullRun: true,
            isTrial: true
        }, {
            onSuccess: () => {
                onCloseModal();
            },
            onError: (error) => {
                console.error('Error creating IIM run:', error);
                if (runWindow) {
                    runWindow.close();
                }
                toast.error('There was an error running the IA trial');
            }
        });
    };
    const inspectionUrl = selectedBuilding
        ? `/api/internal/inspections?building_id=${selectedBuilding.value}&limit=10`
        : null;
    const renderTitle = () => {
        if (allowBack) {
            return (React.createElement("div", { className: "modal-title-with-back" },
                React.createElement("i", { className: "fa-light fa-arrow-left modal-back-arrow", onClick: onClose, role: "button", tabIndex: 0, onKeyDown: (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            onClose();
                        }
                    }, "aria-label": "Go back" }),
                React.createElement("span", null, translate('try_now_title', { namespace }))));
        }
        return translate('try_now_title', { namespace });
    };
    return (React.createElement(Brushaway, { open: isOpen, onClose: onClose, title: renderTitle(), isForm: false, minWidth: 960, wrapperContentClassName: "try-now-modal", customFooter: React.createElement("div", { className: "whats-new-modal__footer" },
            React.createElement(Button, { onClick: onClose, disabled: runIAMutation.isLoading }, translate('cancel', { namespace })),
            React.createElement(RunAiButton, { onClick: handleRunInspectionManager, disabled: !selectedInspection || runIAMutation.isLoading, isLoading: runIAMutation.isLoading })) },
        React.createElement("div", { className: "try-now-modal__content" },
            React.createElement("div", { className: "try-now-modal__explanation" },
                React.createElement("h3", { className: "try-now-modal__explanation-title" }, translate('how_it_works', { namespace })),
                React.createElement("div", { className: "try-now-modal__explanation-text" },
                    React.createElement("p", null,
                        React.createElement("strong", null, translate('trial_explanation_bold', { namespace })),
                        translate('trial_explanation_main', { namespace })),
                    React.createElement("p", null, translate('trial_explanation_footer', { namespace })))),
            React.createElement("div", { className: "try-now-modal__selectors" },
                React.createElement("div", { className: "try-now-modal__selector" },
                    React.createElement(BuildingSelector, { value: selectedBuilding, onChange: handleBuildingChange, placeholder: translate('select_building', { namespace }), variant: "dropdown" })),
                React.createElement("div", { className: "try-now-modal__selector" },
                    React.createElement(ExternalEntitySelector, { url: inspectionUrl || '', value: ((_a = selectedInspection === null || selectedInspection === void 0 ? void 0 : selectedInspection.id) === null || _a === void 0 ? void 0 : _a.toString()) || '', onChange: handleInspectionChange, placeholderText: translate('select_inspection', { namespace }), allowClear: false, showSearch: true, label: "Inspection", variant: "dropdown" }))))));
}
